import { createSelector } from 'reselect'

import { selectGroups } from 'selectors/selectGroups'

export const selectIsUserLead = createSelector(
  [selectGroups],
  (groups) => groups.includes('Leads') || groups.includes('Alpha')
)
